import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { BiographyComponent } from './biography/biography.component';
import { BudgetComponent } from './budget/budget.component';
import { ClientsComponent } from './clients.component';


const routes: Routes = [
  {path: '', component: ClientsComponent ,
    children: [
      {path: '', component: LandingComponent},
      {path: 'biography', component: BiographyComponent },
      {path: 'appointments', component: AppointmentsComponent},
      {path: 'budget', component: BudgetComponent}
  ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientsRoutingModule { }
